/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

import type {App} from 'vue'
import {createPinia} from 'pinia'
import router from '@/router'
import {createHead} from '@unhead/vue/client'

const pinia = createPinia()

export function registerPlugins(app: App) {
    const head = createHead()

    app.use(router).use(pinia).use(head)
}
